import type { AxiosResponse } from 'axios'

export interface ResponseParser<T = AxiosResponse> {
  parse(response: T, chain: ResponseParserChain): T
}

export default class ResponseParserChain<T = AxiosResponse> {
  private parsers: Array<ResponseParser<T>>
  private index: number

  constructor(parsers: Array<ResponseParser<T>>) {
    this.parsers = parsers ? parsers : []
    this.index = 0
  }

  doParse(response: T, chain: ResponseParserChain) {
    if (this.index == this.parsers.length) {
      return response
    }

    const parser = this.parsers[this.index]

    this.index++

    return parser.parse(response, chain)
  }
}
